import Axios from "axios";

export default {

  /**
   * 第二方项目列表
   */
  extraProjectList() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectSecondParty`);
  },

  /**
   * 明源项目列表
   */
  MYProjectList() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectMingyuan`);
  },

  /**
   * 第二方项目是否使用过
   * @param {*} project_second_party_code 
   */
  extraProjectIsUsed(
    project_second_party_code
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectSecondParty/used/check`, {
      params: {
        project_second_party_code
      }
    });
  },

  /**
   * 项目
   */
  project() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project`);
  },

  /**
   * 列表
   * @param {*} project_attr_name
   * @param {*} province_area_id 
   * @param {*} city_area_id 
   * @param {*} district_area_id 
   * @param {*} page 
   */
  listPage(
    project_attr_name,
    province_area_id,
    city_area_id,
    district_area_id,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/page`, {
      params: {
        project_attr_name,
        province_area_id,
        city_area_id,
        district_area_id,
        page
      }
    });
  },

  /**
   * 新增
   * @param {*} project_second_party_code
   * @param {*} project_second_party_name
   * @param {*} province_area_id 
   * @param {*} city_area_id 
   * @param {*} district_area_id 
   * @param {*} project_attr_address 
   * @param {*} project_attr_lat 
   * @param {*} project_attr_lng 
   */
  add(
    project_second_party_name,
    project_second_party_code,
    mingyuan_project_guid,
    province_area_id,
    city_area_id,
    district_area_id,
    project_attr_address,
    project_attr_lat,
    project_attr_lng
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/project`, {
      project_second_party_name,
      project_second_party_code,
      mingyuan_project_guid,
      province_area_id,
      city_area_id,
      district_area_id,
      project_attr_address,
      project_attr_lat,
      project_attr_lng
    });
  },

  /**
   * 编辑
   * @param {*} projectId 
   * @param {*} province_area_id 
   * @param {*} city_area_id 
   * @param {*} district_area_id 
   * @param {*} project_attr_address 
   * @param {*} project_attr_lat 
   * @param {*} project_attr_lng 
   */
  edit(
    projectId,
    province_area_id,
    city_area_id,
    district_area_id,
    project_attr_address,
    project_attr_lat,
    project_attr_lng
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/project/${projectId}`, {
      province_area_id,
      city_area_id,
      district_area_id,
      project_attr_address,
      project_attr_lat,
      project_attr_lng
    });
  },

  /**
   * 删除
   * @param {*} projectId 
   */
  del(
    projectId
  ) {
    return Axios.delete(`${process.env.VUE_APP_PREFIX}/project/${projectId}`);
  },

  /**
   * 详情
   * @param {*} projectId 
   */
  info(
    projectId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}`);
  },
  
  /**
   * 项目员工列表
   * @param {*} projectId 
   */
  staffListPage(
    projectId,
    keyword,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/user/page`, {
      params: {
        keyword,
        page
      }
    });
  },

  /**
   * 项目员工详情
   * @param {*} userId 
   */
  staffInfo(
    userId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/user/${userId}`);
  },

  /**
   * 项目编辑员工
   * @param {*} userId 
   */
  editStaff(
    userId,
    user_attr_name,
    user_attr_gender,
    user_attr_phone,
    user_attr_department,
    user_attr_title,
    face_attachments_id
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/user/${userId}`, {
      user_attr_name,
      user_attr_gender,
      user_attr_phone,
      user_attr_department,
      user_attr_title,
      face_attachments_id
    });
  },

  /**
   * 项目删除员工
   * @param {*} projectId 
   * @param {*} user_ids 
   */
  delStaff(
    projectId,
    user_ids
  ) {
    return Axios.delete(`${process.env.VUE_APP_PREFIX}/project/${projectId}/users`, {
      params: {
        user_ids
      }
    });
  },

  /**
   * 项目同步员工
   * @param {*} projectId 
   */
  syncStaff(
    projectId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/user/sync`);
  },

  /**
   * 轨迹列表
   * @param {*} userId 
   * @param {*} projectId 
   */
  logList(
    userId,
    projectId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/user/${userId}/project/${projectId}/visit`);
  },

  /**
   * 轨迹详情列表
   * @param {*} userId 
   * @param {*} projectId 
   * @param {*} day 
   */
  logInfoList(
    userId,
    projectId,
    day
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/user/${userId}/project/${projectId}/visit/day/${day}`);
  },

  /**
   * 外部员工列表分页
   * @param {*} projectId 
   */
  externalStaffListPage(
    projectId,
    keyword,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/externalStaff/page`, {
      params: {
        keyword,
        page
      }
    });
  },

  /**
   * 外部员工详情
   * @param {*} projectId 
   * @param {*} projectCustomerId 
   */
  externalStaffInfo(
    projectId,
    projectCustomerId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/externalStaff/${projectCustomerId}`);
  },

  /**
   * 外部员工轨迹列表
   * @param {*} projectCustomerId 
   */
  externalStaffLogList(
    projectCustomerId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectCustomer/${projectCustomerId}/visit/day`);
  },

  /**
   * 外部员工轨迹详情
   * @param {*} projectCustomerId 
   * @param {*} day 
   */
  externalStaffLogInfoList(
    projectCustomerId,
    day
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectCustomer/${projectCustomerId}/visit/day/${day}`);
  },

  /**
   * 项目设备列表
   * @param {*} projectId 
   */
  deviceList(
    projectId,
    keyword
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/device/control`, {
      params: {
        keyword
      }
    });
  },

  /**
   * 项目设备摄像头列表
   * @param {*} projectId 
   * @param {*} deviceId 
   */
  deviceCameraListPage(
    projectId,
    deviceId,
    page,
    keyword
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/device/${deviceId}/camera/page`, {
      params: {
        page,
        keyword
      }
    });
  },

  /**
   * 项目设备类型
   */
  deviceType() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/device/controlType`);
  },

  /**
   * 添加设备
   * @param {*} projectId 
   * @param {*} device_type 
   * @param {*} device_name 
   * @param {*} device_sn 
   */
  addDevice(
    projectId,
    device_type,
    device_name,
    device_sn
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/project/${projectId}/device`, {
      device_type,
      device_name,
      device_sn
    });
  },

  /**
   * 编辑设备
   * @param {*} projectId 
   * @param {*} deviceId 
   * @param {*} device_type 
   * @param {*} device_name 
   * @param {*} device_sn 
   */
  editDevice(
    projectId,
    deviceId,
    device_name
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/project/${projectId}/device/${deviceId}`, {
      device_name
    });
  },

  /**
   * 删除设备
   * @param {*} projectId 
   * @param {*} deviceId 
   */
  delDevice(
    projectId,
    deviceId
  ) {
    return Axios.delete(`${process.env.VUE_APP_PREFIX}/project/${projectId}/device/${deviceId}`);
  },

  /**
   * 设备详情
   * @param {*} projectId 
   * @param {*} deviceId 
   */
  deviceInfo(
    projectId,
    deviceId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/device/${deviceId}`);
  },
  
  /**
   * 编辑一体机
   * @param {*} projectId 
   * @param {*} deviceId 
   * @param {*} device_aio_attr_face_living_is_on 
   * @param {*} device_aio_attr_face_match 
   * @param {*} device_aio_attr_distance 
   */
  editAio(
    projectId,
    deviceId,
    device_aio_attr_face_living_is_on,
    device_aio_attr_face_match,
    device_aio_attr_distance
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/project/${projectId}/device/${deviceId}/aio`, {
      device_aio_attr_face_living_is_on,
      device_aio_attr_face_match,
      device_aio_attr_distance
    })
  },
  
  /**
   * 重启盒子
   * @param {*} projectId 
   * @param {*} deviceId 
   */
  restartBox(
    projectId,
    deviceId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/device/${deviceId}/reboot`);
  },

  /**
   * 添加摄像头
   * @param {*} device_name 
   * @param {*} device_camera_attr_stream_url 
   * @param {*} device_camera_attr_location 
   */
  addCamera(
    projectId,
    deviceId,
    device_name,
    device_camera_attr_resolution_width,
    device_camera_attr_resolution_height,
    device_camera_attr_stream_url,
    device_camera_attr_location
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/project/${projectId}/device/${deviceId}/camera`, {
      device_name,
      device_camera_attr_resolution_width,
      device_camera_attr_resolution_height,
      device_camera_attr_stream_url,
      device_camera_attr_location
    })
  },

  /**
   * 编辑摄像头
   * @param {*} projectId 
   * @param {*} deviceId 
   * @param {*} device_name 
   * @param {*} device_sn 
   * @param {*} device_camera_attr_stream_url 
   * @param {*} device_camera_attr_location 
   */
  editCamera(
    projectId,
    deviceId,
    device_name,
    device_camera_attr_resolution_width,
    device_camera_attr_resolution_height,
    device_camera_attr_stream_url,
    device_camera_attr_location
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/project/${projectId}/device/${deviceId}/camera`, {
      device_name,
      device_camera_attr_resolution_width,
      device_camera_attr_resolution_height,
      device_camera_attr_stream_url,
      device_camera_attr_location
    });
  },

  /**
   * 摄像头分辨率参数
   */
  cameraResolutionParam() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/device/cameraResolution`);
  },

  /**
   * 项目账号列表
   * @param {*} projectId 
   * @param {*} keyword 
   */
  accountListPage(
    projectId,
    page,
    keyword
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/account/page`, {
      page,
      keyword
    });
  },

  /**
   * 账号权限菜单
   */
  accountMenuList() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectPermission`);
  },

  /**
   * 增加账号
   * @param {*} projectId 
   * @param {*} account_attr_phone 
   * @param {*} account_attr_name 
   * @param {*} account_attr_title
   * @param {*} permission_ids 
   * @param {*} account_status 
   */
  addAccount(
    projectId,
    account_attr_phone,
    account_attr_name,
    account_attr_title,
    permission_ids,
    account_status
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/project/${projectId}/account`, {
      account_attr_phone,
      account_attr_name,
      account_attr_title,
      permission_ids,
      account_status
    });
  },

  /**
   * 编辑账号
   * @param {*} projectId 
   * @param {*} accountId 
   * @param {*} account_attr_phone
   * @param {*} account_attr_name
   * @param {*} account_attr_title 
   * @param {*} permission_ids 
   * @param {*} account_status 
   */
  editAccount(
    projectId,
    accountId,
    account_attr_phone,
    account_attr_name,
    account_attr_title,
    permission_ids,
    account_status
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/project/${projectId}/account/${accountId}`, {
      account_attr_phone,
      account_attr_name,
      account_attr_title,
      permission_ids,
      account_status
    });
  },

  /**
   * 删除账号
   * @param {*} projectId 
   * @param {*} accountId 
   */
  delAccount(
    projectId,
    accountId
  ) {
    return Axios.delete(`${process.env.VUE_APP_PREFIX}/project/${projectId}/account/${accountId}`);
  },

  /**
   * 账号详情
   * @param {*} projectId 
   * @param {*} accountId 
   */
  accountInfo(
    projectId,
    accountId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/account/${accountId}`);
  },

  /**
   * 检测手机号是否存在
   * @param {*} phone 
   */
  accountPhoneIsExist(
    projectId,
    phone
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/account/phone/${phone}/exist`);
  },

  /**
   * 参数详情
   * @param {*} projectId 
   */
  paramInfo(
    projectId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/${projectId}/config`);
  },
  
  /**
   * 参数设置详情
   */
  paramSettingsInfo() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/project/config/field`);
  },

  /**
   * 重复识别间隔设置
   * @param {*} projectId 
   * @param {*} recognition_step_time
   */
  paramTimeSettings(
    projectId,
    recognition_step_time
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/project/${projectId}/config/stepTime`, {
      recognition_step_time
    });
  },

  /**
   * 员工自动检测设置
   * @param {*} projectId
   * @param {*} external_staff_recognition_enable
   * @param {*} external_staff_recognition_visit_days_times
   */
  paramAutoDetectSettings(
    projectId,
    external_staff_recognition_enable,
    external_staff_recognition_visit_days_times
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/project/${projectId}/config/externalStaffRecognition`, {
      external_staff_recognition_enable,
      external_staff_recognition_visit_days_times
    });
  },

  /**
   * 风控日报提醒
   * @param {*} projectId
   * @param {*} project_config_risk_report_daily_recieve_user_ids
   */
  paramRiskSettings(
    projectId,
    project_config_risk_report_daily_recieve_user_ids
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/project/${projectId}/config/riskReportDailyRecieveUserIdsSave`, {
      project_config_risk_report_daily_recieve_user_ids
    });
  },

  /**
   * 设备故障提醒
   * @param {*} projectId
   * @param {*} wechat_user_ids
   */
  paramDeviceBrokenSettings(
    projectId,
    wechat_user_ids
  ) {
    return Axios.put(`${process.env.VUE_APP_PREFIX}/project/${projectId}/config/alarm`, {
      wechat_user_ids
    });
  }

}